import { Grid } from '../components/layout/Box'

export type TGridPlacementProps = Pick<PropsOf<typeof Grid>, 'gridRow' | 'gridColumn'>

type TValue = (number & {}) | (string & {}) | `all`
type TOptions = {
  row?: TValue
  col?: TValue
}

type TGetGridPlacement = (options: TOptions) => TGridPlacementProps

// the entire row or column, CSS value
const ALL = `1 / -1`

// TODO use where it's useful

/**
 * returns `gridRow` & `gridColumn` props for selected `row` & `column` values
 *
 * @example const firstRow = getGridPlacement({row: `all`, col: 1})
 * // { gridRow: 1, gridColumn: '1 / -1'}
 */
export const getGridPlacement: TGetGridPlacement = ({ row, col }) => {
  const gridRow = row === `all` ? ALL : row
  const gridColumn = col === `all` ? ALL : col

  return { gridRow, gridColumn }
}

/**
 * predefined `gridRow` & `gridColumn` props for
 * specific grid placement such as `firstRow`
 *
 * @example <Box {...GRID.firstRow} /> // { gridRow: 1, gridColumn: '1 / -1'}
 */
export const GRID = {
  firstColumn: getGridPlacement({ row: `all`, col: 1 }),
  firstRow: getGridPlacement({ row: 1, col: `all` }),
} as const
